import React, { useEffect, useState } from 'react';

import { SnackbarManager } from '@arens/aren-design-system';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { ErrorPage } from './error-page';
import { LoadingView } from './loading-view';
import { LoginAdvanced } from './loginAdvanced';
import { LoginCE } from './loginCE';
import { getAdvancedSupported } from './services/advanced-supported';
import { ThemeProvider } from './theme-provider/theme-provider';

type Error = {
	errorMessage: string;
};

type AdvancedSupport = {
	supported: boolean;
};

type Loading = {
	isLoading: true;
};

export function App(): React.JSX.Element {
	const [apiResponse, setApiResponse] = useState<AdvancedSupport | Loading | Error>({
		isLoading: true
	});

	useEffect(() => {
		setApiResponse({ isLoading: true });
		getAdvancedSupported().then((data) => {
			if ('errorMessage' in data) {
				setApiResponse({
					errorMessage: ''
				});
				return;
			}
			setApiResponse({
				supported: data.supported
			});
		});
	}, []);
	const errorResponse = apiResponse && 'errorMessage' in apiResponse;
	const isLoading = !apiResponse || (apiResponse && 'isLoading' in apiResponse);
	const supportedResponse = apiResponse && 'supported' in apiResponse;

	return (
		<ThemeProvider>
			<SnackbarManager>
				<Router>
					<Switch>
						{errorResponse && <ErrorPage />}
						{isLoading && <LoadingView />}
						{supportedResponse && apiResponse.supported && <LoginAdvanced />}
						{supportedResponse && !apiResponse.supported && <LoginCE />}
					</Switch>
				</Router>
			</SnackbarManager>
		</ThemeProvider>
	);
}
